import { Spinner } from '@blueprintjs/core';
import { Button, InfoBox, styled } from '@moleculeone/ui';

import { EditorSpacer } from '@f/components/shared/compound-editor/CompoundEditor';

import { AnalogsProps } from '../hooks/useAnalogs';

const AnalogsActionsContainer = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '$3',
});

const LoadingAnalogs = styled('div', {
  display: 'flex',
  gap: '$4',
  alignItems: 'center',
  fontSize: '$3',
  color: '$slate11',
});
const StartGeneratingAnalogs = styled('div', {
  'display': 'flex',
  'gap': '$5',
  'alignItems': 'center',
  '& em': {
    color: '$slate10',
  },
});

interface AnalogsActionsProps extends Pick<AnalogsProps, 'generateAnalogs' | 'isGeneratingAnalogs'> {
  onBack: () => void;
}
export function AnalogsActions(props: AnalogsActionsProps) {
  const { onBack, generateAnalogs, isGeneratingAnalogs } = props;

  return (
    <EditorSpacer isAnalogGenerationOpen={true}>
      <InfoBox
        title="Analog Generation is an early preview feature"
        icon="warning"
        type="warning"
        size="small"
        css={{ marginBottom: '$4' }}
      >
        The feature utilizes the OpenAI API for its functionality. By using this feature, you acknowledge and agree that
        all data input may be transmitted to and processed by OpenAI. The handling, storage, and use of your data will
        be subject to OpenAI's Terms of Use and Privacy Policy. Your continued use of the Analog Generation Tool
        constitutes acceptance of these terms.
      </InfoBox>
      <AnalogsActionsContainer>
        <Button
          weight="minimal"
          text="Back to editor"
          icon="arrow_back"
          onClick={() => {
            onBack();
          }}
          size="small"
        />
        <StartGeneratingAnalogs>
          <em>Generation takes about 1 minute</em>
          {isGeneratingAnalogs ? (
            <LoadingAnalogs>
              <Spinner size={18} /> Generating analogs
            </LoadingAnalogs>
          ) : (
            <Button theme="purple" text="Generate analogs" icon="hub" onClick={generateAnalogs} />
          )}
        </StartGeneratingAnalogs>
      </AnalogsActionsContainer>
    </EditorSpacer>
  );
}
